"use strict";

var _interopRequireDefault = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _createClass2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/createClass.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _inherits2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/inherits.js"));
var _createSuper2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/createSuper.js"));
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var App = /*#__PURE__*/function (_Vue) {
  (0, _inherits2.default)(App, _Vue);
  var _super = (0, _createSuper2.default)(App);
  function App() {
    (0, _classCallCheck2.default)(this, App);
    return _super.apply(this, arguments);
  }
  return (0, _createClass2.default)(App);
}(_vuePropertyDecorator.Vue);
App = (0, _tslib.__decorate)([_vuePropertyDecorator.Component], App);
var _default = App;
exports.default = _default;